module.exports = __webpack_public_path__ + "img/car-A-1.87fea59e.jpg";